// Definición de environments
const API_HOSTS_ENVIRONMENTS: { [stage: string]: string } = {
  dev:'http://api.dev.consorcioabierto.local:8080',
  test: 'https://testing-api.pub.consorcioabierto.com:8060',
  prod: 'https://api.consorcioabierto.com',
  // Agregar prod_px/staging
};

// URL Login
export const PATH_LOGIN: string = '/login';

// Los stages son definidos en el proyecto de amplify. Default dev, en branches testing y master se convierte en "testing" y "prod" respectivamente.
export const APP_ENVIRONMENT: string = <string> process.env.VUE_APP_STAGE;
export const API_HOST: string = API_HOSTS_ENVIRONMENTS[APP_ENVIRONMENT];

/**
 * Rol válido para el usuario: Utilizado para validar el login
 */
export const ROLE_COMERCIAL: string = 'COMERCIAL';

/**
 * Chequeo de modo desarrollo, de acuerdo a stage (es configurado en proyecto Amplify de acuerdo al branch cuando se deploya, por defecto dev)
 *
 * Utilizado para omitir requerimientos a AWS en modo Dev (Fake user)
 */
export function isDevMode() {
  return APP_ENVIRONMENT === 'dev';
}
